import { API_BASE_URL, API_PATHS, } from "../constants/api.constants";

export const uploadImage = async (file, token) => {

  const formData = new FormData();
  formData.append("file", file);

  const response = await fetch(`${API_BASE_URL}${API_PATHS.teacheruploadFile}`, {
    method: "POST",
    body: formData,
    headers: {
      "x-access-token": token,
    },
  });

  if (!response.ok) {
    throw new Error("Failed to upload image");
  }

  const data = await response.json();


  if (data?.data?.fileUrl) {
    return data.data.fileUrl;
  }

  throw new Error(data.message || "Upload error");
};

export const uploadsuperadminImage = async (file, token) => {

  const formData = new FormData();
  formData.append("file", file);

  const response = await fetch(`${API_BASE_URL}${API_PATHS.sadminuploadFile}`, {
    method: "POST",
    body: formData,
    headers: {
      "x-access-token": token,
    },
  });

  if (!response.ok) {
    throw new Error("Failed to upload image");
  }

  const data = await response.json();


  if (data?.data?.fileUrl) {
    return data.data.fileUrl;
  }

  throw new Error(data.message || "Upload error");
};

export const uploadadminImage = async (file, token) => {
  const formData = new FormData();
  formData.append("file", file);

  const response = await fetch(
    `${API_BASE_URL}${API_PATHS.adminuploadFile}`,
    {
      method: "POST",
      body: formData,
      headers: {
        "x-access-token": token,
      },
    }
  );

  if (!response.ok) {
    throw new Error("Failed to upload image");
  }

  const data = await response.json();

  if (data?.data?.fileUrl) {
    return data.data.fileUrl;
  }

  throw new Error(data?.message || "Upload error");
};
